// import { useAuthStore } from '@/stores/auth';
import API from '@/assets/libraries/API_Requests';
import { LOAD_FIREWORK_LIMIT } from '@/constants';
import { removeNulls } from '@/helpers/commonFunctions';

// const authStore = useAuthStore();

export async function getFireworksCollections() {
	const response = await API.Call('GET', `${API.CSC_API_URL}/fireworks/collections?include_fireworks=true&include_default_all_collection=true`);

	if (response.error != undefined) {
		throw new Error(JSON.stringify(response.error));
	}

	let collections = removeNulls(response);

	//TODO: Implement actual translation. When trying to import the i18n file, every change would break the app due to a vite issue.
	let primary_collection = collections.filter((collection) => collection.is_primary_collection == true)[0];
	if (primary_collection != undefined) {
		// primary_collection.name = i18n.global.t('fireworks_section.primary_collection_name');
		// primary_collection.description = i18n.global.t('fireworks_section.primary_collection_description');
	}

	return collections;
}

export async function getMyFireworks({ page = 0, search_value = undefined, current_sort_column = undefined, selected_collection_id = undefined, current_sort_direction = undefined, page_limit = LOAD_FIREWORK_LIMIT, signal } = {}) {
	var query_params = new URLSearchParams();

	if (page != undefined) {
		query_params.set('page', page);
	}
	if (page_limit != undefined) {
		query_params.set('limit', page_limit);
	}
	if (search_value != undefined) {
		query_params.set('search', search_value);
	}
	if (current_sort_column != undefined) {
		query_params.set('column_to_sort', current_sort_column);
	}

	if (selected_collection_id != undefined) {
		query_params.set('collection_id', selected_collection_id);
	}

	if (current_sort_direction == 'ascending') {
		query_params.set('column_sort', 'ASC');
	} else if (current_sort_direction == 'descending') {
		query_params.set('column_sort', 'DESC');
	}

	const response = await API.Call('GET', `${API.CSC_API_URL}/fireworks?${query_params.toString()}`, {}, 'application/json', signal);

	if (response.error != undefined) {
		throw new Error(JSON.stringify(response.error));
	}

	const fireworks = removeNulls(response.fireworks);
	const pagination = response?.pagination;
	return { fireworks, pagination };
}

export function openAFirework(fireworkID, inventory_item_id) {
	let windowWidth = 500,
		windowHeight = 735;
	if (screen.width > 1100) {
		windowWidth = 1150;
	}
	if (screen.height < 750) {
		windowHeight = screen.height - 100;
	}
	let left = screen.width / 2 - windowWidth / 2;
	let top = screen.height / 2 - windowHeight / 2;

	if (inventory_item_id) {
		window.open(API.COBRA_PORTAL_URL + `/fireworks/${fireworkID}/${inventory_item_id}/?open_via=CSC`, 'My Firework', 'width=' + windowWidth + ',height=' + windowHeight + ',left=' + left + ',top=' + top + ',resizable=yes');
	} else {
		window.open(API.COBRA_PORTAL_URL + '/fireworks/' + fireworkID + '?state=view&open_via=CSC', 'My Firework', 'width=' + windowWidth + ',height=' + windowHeight + ',left=' + left + ',top=' + top + ',resizable=yes');
	}
}

export async function openWikiFirework() {
	window.wiki_window = window.open('https://www.wikifireworks.com', '_blank');

	const response = await API.Call('GET', `${API.CSC_API_URL}/wiki/token`);

	if (response.error != undefined) {
		console.log('Wiki token error', response.error);
		throw new Error(JSON.stringify(response.error));
	}

	console.log('wiki token', response);
	setTimeout(() => {
		window.wiki_window.postMessage({ 'message': 'store_wiki_token', wiki_token: response.token }, '*');
	}, 4000);
}

export async function getFireworkData(firework_id) {
	if (firework_id == undefined) {
		throw new Error('Firework ID is required');
	}

	const response = await API.Call('GET', `${API.CSC_API_URL}/firework/${firework_id}`);

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}

export async function updateSecondaryFireworkColumns(columns) {
	const response = await API.Call('PUT', `${API.CSC_API_URL}/users/settings`, { fireworks_section_additional_columns: columns });

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}

export async function getManyFireworkData(firework_ids) {
	if (firework_ids == undefined) {
		throw new Error('Firework IDs are required');
	}

	const query_params = new URLSearchParams();
	query_params.set('firework_ids', firework_ids.join(','));

	const response = await API.Call('GET', `${API.CSC_API_URL}/fireworks/many?${query_params.toString()}`);

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}
